// src/components/ExitButton/index.tsx

import React from "react";

interface ExitButtonProps {
  /** Optional callback for when the user clicks the button. */
  onExit?: () => void;

  /** Path or import for your exit icon (e.g. arrow). */
  iconSrc: string;
}

const ExitButton: React.FC<ExitButtonProps> = ({ onExit, iconSrc }) => {
  const handleClick = () => {
    if (onExit) onExit();
  };

  return (
    <button
      onClick={handleClick}
      aria-label="Exit"
      className="
        w-[2.375rem]
        h-[1.625rem]
        flex-shrink-0
        border
        border-[#d4d6db]
        rounded-[13px]
        bg-white
        cursor-pointer
        outline-none
        flex
        items-center
        justify-center
      "
    >
      <img
        src={iconSrc}
        alt="Exit Icon"
        className="w-[1rem] h-[1rem] flex-shrink-0"
      />
    </button>
  );
};

export default ExitButton;
